// Anita Week 5 / Day 1 — Хороший вопрос и ключевые слова / A Good Question and
// Keywords. Grade-3 rigor: multi-step + × + ÷ (via 1/3 of 60 = 60 ÷ 3).

const day1 = {
  id: 'day-1',
  studentId: 'anita',
  weekId: 'week-5',
  dayId: 'day-1',
  status: 'active',
  title: 'Хороший вопрос и ключевые слова / A Good Question and Keywords',
  shortTitle: 'Вопрос и ключевые слова / Question and Keywords',
  theme:
    'Анита учится задавать точный вопрос и подбирать ключевые слова для поиска. / Anita learns to ask a precise question and pick keywords.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'information-literacy', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro:
    'Нимни показывает Аните: точный вопрос находит точный ответ. Сегодня Анита учится задавать хороший вопрос и подбирать ключевые слова. / Nimny shows that a precise question finds a precise answer.',
  goals: [
    'Понять, что такое хороший вопрос. / Understand a good question.',
    'Подбирать ключевые слова к теме. / Pick keywords for a topic.',
    'Считать карточки вопросов и точные ответы. / Count question cards.',
    'Найти лучший вопрос из двух вариантов. / Choose the better question.',
    'Написать простые русские слова темы. / Write theme words in Russian.'
  ],
  vocabulary: [
    { term: 'вопрос / question', definition: 'то, что мы хотим узнать. / what we want to learn.' },
    { term: 'ответ / answer', definition: 'то, что мы нашли. / what we found.' },
    { term: 'искать / to search', definition: 'смотреть, чтобы найти. / to look to find.' },
    { term: 'точно / precisely', definition: 'без ошибки. / without a mistake.' },
    { term: 'слово / word', definition: 'часть языка. / a piece of language.' },
    { term: 'ключевое слово / keyword', definition: 'главное слово поиска. / main search word.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы / Theme Words',
      prompt: 'Прочитай по-русски:\nвопрос\nответ\nискать\nточно\nслово\nключевое',
      ruPrimaryText: 'Прочитай 6 слов темы.',
      enHelpText: 'Read 6 theme words in Russian.',
      answer: 'Анита пробует читать русские слова.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение / Short Reading',
      prompt: 'Прочитай по-русски:\nТочный вопрос помогает найти точный ответ.\nКлючевые слова — это главные слова темы.\nЕсли вопрос слишком общий, ответ тоже будет общий.\nХороший исследователь всегда думает над словами вопроса.\nПоэтому мы задаём вопрос вместе с родителем.',
      ruPrimaryText: 'Прочитай 5 фраз про точный вопрос.',
      enHelpText: 'A precise question finds a precise answer. Keywords are the main words of the topic.',
      answer: 'Анита пробует читать 5 фраз.' },
    { id: 'math-check-cards', type: 'text', title: 'Задание 3 — Карточки вопросов / Question Cards',
      prompt: 'У Аниты 60 карточек с вопросами. 1/3 карточек она уже проверила, ещё 12 карточек отложила.\n\nОтветь:\n1. Сколько карточек в 1/3?\n2. Сколько карточек уже прошли?\n3. Сколько карточек осталось проверить?',
      ruPrimaryText: 'Дробь 1/3 от 60 + сложение + остаток.',
      enHelpText: 'Find 1/3 of 60 first, add 12, then subtract from 60.',
      answer: '1) 60 ÷ 3 = 20. 2) 20 + 12 = 32. 3) 60 − 32 = 28 карточек.' },
    { id: 'math-keyword-groups', type: 'text', title: 'Задание 4 — Группы ключевых слов / Keyword Groups',
      prompt: 'Анита написала 4 группы ключевых слов. В каждой группе по 6 слов. Потом она убрала 5 лишних слов.\n\nОтветь:\n1. Сколько слов было всего?\n2. Сколько слов осталось?',
      ruPrimaryText: 'Умножение групп × слова + вычитание.',
      enHelpText: 'Multiply groups by words per group, then subtract 5.',
      answer: '1) 4 × 6 = 24. 2) 24 − 5 = 19 слов.' },
    { id: 'math-search-time', type: 'text', title: 'Задание 5 — Время поиска / Search Time',
      prompt: 'Первый поиск занял 14 минут, второй — 18 минут, третий — 13 минут.\nПлан был 60 минут.\n\nОтветь:\n1. Сколько минут всего?\n2. Сколько минут осталось из плана?',
      ruPrimaryText: 'Сумма трёх поисков + остаток от плана.',
      enHelpText: 'Add three search times; subtract from 60.',
      answer: '1) 14 + 18 + 13 = 45 минут. 2) 60 − 45 = 15 минут.' },
    { id: 'math-precise-count', type: 'text', title: 'Задание 6 — Точные вопросы / Precise Questions',
      prompt: 'Из 40 вопросов 24 были точными.\n\nОтветь:\n1. Сколько вопросов были неточными?',
      ruPrimaryText: 'Простое вычитание.',
      enHelpText: 'Subtract 24 from 40.',
      answer: '1) 40 − 24 = 16 неточных вопросов.' },
    { id: 'logic-better-question', type: 'text', title: 'Задание 7 — Лучший вопрос / Best Question',
      prompt: 'Найди лучший вопрос:\nA: «животные»\nB: «какие животные живут рядом с водой во Флориде»\n\nОтветь 1–3 предложениями: какой вопрос лучше и почему?',
      ruPrimaryText: 'Логика: точный вопрос > общий.',
      enHelpText: 'A precise question with a place, animal type and habitat is better than one word.',
      answer: 'Ожидаемо: «B, потому что он точный: указано где, какие животные и какое место».' },
    { id: 'spelling-day1', type: 'text', title: 'Задание 8 — Правописание / Spelling',
      prompt: 'Напиши:\nвопрос\nответ\nискать\nточно\nслово\n\nВставь буквы:\nв_прос\nо_вет\nи_кать\nт_чно\nсл_во',
      ruPrimaryText: 'Напиши 5 слов темы и вставь буквы.',
      enHelpText: 'Write 5 theme words and fill in the letters.',
      answer: 'вопрос, ответ, искать, точно, слово.' },
    { id: 'creative-my-question', type: 'text', title: 'Задание 9 — Мой точный вопрос / My Precise Question',
      prompt: 'Напиши 2 предложения:\n1. Общий вопрос: «Я хочу узнать про ______».\n2. Точный вопрос: «Какие ______ живут в ______ и что они едят?»\n\nНарисуй маленькую карточку-проект своего точного вопроса.',
      ruPrimaryText: 'Составь общий и точный вопрос + нарисуй карточку.',
      enHelpText: 'Write a general and a precise question, and draw a card.',
      answer: 'Open-ended. 2 связные фразы с точным вопросом.' },
    { id: 'speech-day1', type: 'text', title: 'Задание 10 — Объясни родителю / Explain to Parent',
      prompt: 'Скажи родителю по-русски:\nЯ ищу точный ответ.\nСначала я думаю над словами вопроса.\nКлючевые слова — это главные слова.',
      ruPrimaryText: 'Объясни точный вопрос по-русски.',
      enHelpText: 'Tell the parent: I search for a precise answer with keywords.',
      answer: 'Accept if Anita expresses the idea in Russian with support.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Начерти карточки вопросов и таблицу времени поиска в тетради.',
    '2. Реши задачи 3–6.',
    '3. Напиши 5 слов темы.',
    '4. Составь свой точный вопрос.',
    '5. Расскажи родителю.'
  ],
  printWorksheet: {
    title: 'Хороший вопрос и ключевые слова / A Good Question and Keywords',
    subtitle: 'Неделя 5 · День 1 / Week 5 · Day 1',
    pages: [
      {
        title: 'Маршрут дня и математика / Route and Math',
        blocks: [
          { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
          { type: 'text', text: 'Миссия: сегодня ты учишься задавать точный вопрос и подбирать ключевые слова. / Today you learn to ask precise questions.' },
          { type: 'text', text: 'Задание 1 — Слова темы. Прочитай и обведи:' },
          { type: 'list', items: ['вопрос / question', 'ответ / answer', 'искать / to search', 'точно / precisely', 'слово / word', 'ключевое / keyword'] },
          { type: 'text', text: 'Задание 2 — Маленькое чтение:' },
          { type: 'list', items: [
            '□ Точный вопрос помогает найти точный ответ.',
            '□ Ключевые слова — это главные слова темы.',
            '□ Если вопрос слишком общий, ответ тоже общий.',
            '□ Хороший исследователь думает над словами.',
            '□ Мы задаём вопрос вместе с родителем.'
          ] },
          { type: 'text', text: 'Задание 3 — Карточки вопросов. 60 карточек всего.' },
          { type: 'list', items: ['1/3 = 60 ÷ 3 = ___ карточек', '+ 12 отложенных', 'Уже прошли = ___', 'Осталось = 60 − ___ = ___ карточек'] },
          { type: 'text', text: 'Задание 4 — Группы ключевых слов. 4 группы × 6 слов, потом − 5.' },
          { type: 'list', items: ['4 × 6 = ___ слов всего', '___ − 5 = ___ слов осталось'] }
        ]
      },
      {
        title: 'Время, точность и логика / Time, Precision, Logic',
        blocks: [
          { type: 'text', text: 'Задание 5 — Время поиска. Таблица:' },
          { type: 'list', items: [
            'Поиск | Минуты',
            '  1   |  14',
            '  2   |  18',
            '  3   |  13',
            'Всего минут: 14 + 18 + 13 = ___',
            'План 60 минут, осталось: 60 − ___ = ___'
          ] },
          { type: 'text', text: 'Задание 6 — Точные вопросы. Из 40 вопросов 24 точные.' },
          { type: 'list', items: ['Неточные = 40 − 24 = ___'] },
          { type: 'text', text: 'Задание 7 — Лучший вопрос. Выбери и обоснуй 1–3 предложения:' },
          { type: 'list', items: ['□ A: «животные»', '□ B: «какие животные живут рядом с водой во Флориде»'] },
          { type: 'text', text: 'Почему: _________________________________________________________________________________________' }
        ]
      },
      {
        title: 'Русский и проект / Russian and Project',
        blocks: [
          { type: 'text', text: 'Задание 8 — Правописание:' },
          { type: 'list', items: ['вопрос   ответ   искать   точно   слово', 'в_прос    о_вет    и_кать    т_чно    сл_во'] },
          { type: 'text', text: 'Задание 9 — Мой точный вопрос. Нарисуй маленькую карточку-проект и напиши:' },
          { type: 'list', items: [
            'Общий вопрос: «Я хочу узнать про ______».',
            'Точный вопрос: «Какие ______ живут в ______ и что они едят?»'
          ] },
          { type: 'text', text: 'Задание 10 — Объясни родителю. Скажи:' },
          { type: 'list', items: [
            '□ Я ищу точный ответ.',
            '□ Сначала я думаю над словами вопроса.',
            '□ Ключевые слова — это главные слова.'
          ] },
          { type: 'text', text: 'Parent Check: □ прочитала слова  □ прочитала 5 фраз  □ карточки вопросов  □ группы слов  □ время поиска  □ точные вопросы  □ лучший вопрос B  □ карточка проекта  □ объяснила родителю.' },
          { type: 'text', text: 'Notebook Mode fallback: если нет принтера, начерти таблицы и карточку вопроса в тетради и повтори все задания.' }
        ]
      }
    ]
  },
  parentGuide: {
    whatThisLessonTeaches: 'Как задать точный вопрос и подобрать ключевые слова.',
    howToExplain: 'Скажите: чем точнее слова вопроса, тем точнее ответ.',
    exampleDialogue: 'Parent: 1/3 от 60?\nChild: 20.\nParent: Уже прошли?\nChild: 32.\nParent: Осталось?\nChild: 28.',
    readingSupport: 'Слова «ключевое», «точно» — по слогам.',
    russianSpeechGoal: 'Анита говорит: «Я ищу точный ответ.»',
    spellingCheck: 'Проверить: вопрос, ответ, искать, точно, слово.',
    readingCheck: 'Попытка русского чтения 5 фраз.',
    practicalCheck: 'Точный вопрос вместо общего.',
    discussionPrompts: ['Чем точный вопрос отличается от общего?', 'Что такое ключевое слово?'],
    ifEasy: 'Придумать ещё один точный вопрос.',
    ifDifficult: 'Оставить задания 3 и 6.',
    drawingCriteria: 'Карточка проекта с общим и точным вопросом.',
    goal: 'Анита задаёт точный вопрос, подбирает ключевые слова и работает с 1/3 от 60.',
    mathGoal: 'U.S. Grade 3: 1/3 от 60 через 60 ÷ 3; 4 × 6 − 5; сумма трёх поисков и остаток от плана; 40 − 24.',
    russianGoal: 'Прочитать 6 слов и 5 фраз; написать 5 слов и вставить буквы.',
    readingWritingGoal: '2 предложения (общий и точный вопрос) + логический ответ.',
    practicalGoal: 'Уметь заменить общий вопрос на точный.',
    parentTheoryCard: {
      title: 'Как объяснить точный вопрос',
      purpose: 'Помочь родителю показать разницу между общим и точным вопросом.',
      keyMessage: 'Точный вопрос находит точный ответ.',
      parentScript: [
        '«Смотри: «животные» — это общий вопрос. Он найдёт слишком много.»',
        '«Точный вопрос: где живут, какие, что едят.»',
        '«1/3 от 60 = 60 ÷ 3 = 20. Значит она проверила 20 карточек.»',
        '«Ключевое слово — это главное слово темы.»'
      ],
      practiceSteps: [
        'Спроси Аниту: «О чём ты хочешь узнать?»',
        'Помоги превратить общий вопрос в точный.',
        'Проверь 60 ÷ 3 = 20 вместе.',
        'Помоги сложить 14 + 18 + 13.'
      ],
      paperOnlyNotes: ['Все задания на бумаге.', 'Никаких настоящих переходов по сайтам.'],
      doNotSay: ['Не задавай вопрос за Аниту.', 'Не решай задачи.', 'Не давай готовый ответ без объяснения.']
    },
    keyMessage: 'Точный вопрос, надёжный источник, факт с доказательством, проверка ИИ, опыт про плотность.',
    mathAnswerKey:
      'math-check-cards: 60 ÷ 3 = 20; 20 + 12 = 32; 60 − 32 = 28 карточек.\n' +
      'math-keyword-groups: 4 × 6 = 24; 24 − 5 = 19 слов.\n' +
      'math-search-time: 14 + 18 + 13 = 45 минут; 60 − 45 = 15 минут.\n' +
      'math-precise-count: 40 − 24 = 16 неточных вопросов.',
    spellingAnswerKey: 'вопрос\nответ\nискать\nточно\nслово',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения 6 слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения 5 фраз.' },
      { taskId: 'math-check-cards', answer: '20; 32; 28.' },
      { taskId: 'math-keyword-groups', answer: '24; 19.' },
      { taskId: 'math-search-time', answer: '45; 15.' },
      { taskId: 'math-precise-count', answer: '16.' },
      { taskId: 'logic-better-question', answer: 'B — точный (место, тип, среда).' },
      { taskId: 'spelling-day1', answer: 'вопрос, ответ, искать, точно, слово.' },
      { taskId: 'creative-my-question', answer: 'Общий + точный вопрос.' },
      { taskId: 'speech-day1', answer: 'Идея точного вопроса по-русски.' }
    ],
    check: ['Анита посчитала 1/3 от 60.', 'Анита составила точный вопрос.', 'Анита объяснила, почему B лучше.'],
    commonMistakes: ['«1/3 от 60 = 3.» Правильно: 20.', '«Общий вопрос лучше.» Правильно: точный.'],
    rewardGuidance: 'Базовая награда — 3 нима. Бонус за точный вопрос.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не превращай точный вопрос в реальный поиск в интернете. Всё — на бумаге.',
    safetyNotes: 'Никаких настоящих поисков в интернете. Только тренировка составления вопроса на бумаге.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима', bonuses: [
    { id: 'precise-question', label: 'Бонус за точный вопрос', amount: 1 }
  ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'math-check-cards', 'math-keyword-groups', 'math-search-time', 'math-precise-count', 'logic-better-question', 'spelling-day1', 'creative-my-question', 'speech-day1'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-5-day-2'
};

export default day1;
